<template>
  <VueSelect
    ref="select"
    label="text"
    :get-option-label="formatOption"
    :filterable="false"
    :options="options"
    :value="value"
    @input="getValue"
    @open="onOpen"
    @close="onClose"
    @search="startSearch"
    >
    <template slot="no-options">Nenhum resultado encontrado</template>
    <template #list-footer>
      <li ref="load" class="loader" v-show="hasNextPage">
        Carregando próximos
      </li>
    </template>
  </VueSelect>
</template>

<script>
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: "InputAutocomplete",
  components: {
    VueSelect
  },
  props: {
    id: String,
    label: String,
    size: {
      type: Number,
      default: 20
    },
    value: Object,
    loader: {
      type: Function,
      required: true
    },
    showId: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      hasNextPage: true,
      page: 0
    };
  },
  methods: {
     formatOption(option) {
      if (!option) return ''
      return `${option.name || option.text} ${this.showId ? ' (' + option.id + ')' : ''}`
    },
    getValue(value) {
      this.$emit('input', value)
    },
    async onOpen () {
      if (this.hasNextPage)
      {
        await this.$nextTick();
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect()
      this.clear()
    },
    startSearch() {
      this.clear()
    },
    clear() {
      this.options = []
      this.hasNextPage = true
      this.page = 0
    },
    async infiniteScroll ([{isIntersecting, target}]) {
      
      if (!isIntersecting) {
        return
      }

      const ul = target.offsetParent;
      const scrollTop = target.offsetParent.scrollTop;

      this.loadNext()
      .then(() => {
        ul.scrollTop = scrollTop;
      })
    },
    loadNext() {
      this.page++

      let search = this.$refs.select.search || "";

      return this.loader(search, this.page, this.size)
      .then((data) => {
        this.options = this.options.concat(data)

        if (!data || data.length < this.size) {
          this.hasNextPage = false
        }
      },
      () => {
          this.hasNextPage = false
      })
    }
  },
  mounted () {
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },
  watch:{
    
  }
}
</script>

<style>

.vs__search {
  border-color: transparent !important;
  border: 0 !important;
  margin: 0 !important;
  height: 25px !important;
}
.vs__selected{
  font-size: 16px !important;
  width: max-content;
  white-space: nowrap;
}

.vs__dropdown-menu {
  font-size: 16px !important;
}

.vs__dropdown-option {
  font-size: 16px !important;
}

.vs__selected-options{
  overflow: hidden;
}

.vs__dropdown-toggle{
  max-height: 31px !important;
}
</style>